module.exports = __webpack_public_path__ + "static/media/personality4.06756bbf.jpeg";